import React from "react";
import { rowColumn, tableOptions } from "../../../components/table/Table";
import { assignStatusExternalOptions, assignStatusExternalSecondaryOptions } from "../../utils/assignStatusExternalOptions";
import { getFilterOptions, getTableBuilderFilterOptions } from "../../CommonFunctions";

export enum KindergartenApplicationState {
  pending = "pending",
  submitted = "submitted",
}

export const kindergartenApplicationsListTable = (currPath: string, state: KindergartenApplicationState): rowColumn[] => [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "First Name",
    column: "applicationBase.child.firstName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Child.FirstName",
  },
  {
    label: "Last Name",
    column: "applicationBase.child.lastName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Child.LastName",
  },
  {
    label: "Kindergarten",
    column: "applicationBase.kindergarten.fundedKinderName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Kindergarten.FundedKinderName",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.applicationBase.kindergarten?.fundedKinderName === "Other"
            ? rowData.applicationBase.kindergarten?.kindergartenNameOther
            : rowData.applicationBase.kindergarten?.fundedKinderName}
        </p>
      );
    },
  },
  {
    label: "Status",
    column: "applicationBase.assignStatus.statusComputed",
    type: "string",
    allowSort: true,
    disableSearch: true,
    sortOn: "ApplicationBase.AssignStatus.StatusComputed",
    isFilter: state === KindergartenApplicationState.submitted,
    filterType: "multiselect",
    filterElements: getFilterOptions(assignStatusExternalOptions, getSecondaryStatusOptions()),
  },
  {
    label: "Actions",
    body: (rowData) => <a href={`${currPath}/${rowData.id}`}>View Details</a>,
  },
];

export function kinderTableOptionsBuilder(state: KindergartenApplicationState): tableOptions {
  let searchFilter: string[] = [];

  if (state === KindergartenApplicationState.pending) {
    searchFilter = ["Application - Not submitted"];
  } else if (state === KindergartenApplicationState.submitted) {
    const modifiedSecondaryOptions = getSecondaryStatusOptions();
    searchFilter = getTableBuilderFilterOptions(assignStatusExternalOptions, modifiedSecondaryOptions);
  }

  return {
    sortField: undefined,
    sortOrder: undefined,
    filters: {
      "applicationBase.assignStatus.statusComputed": {
        searchFilter: searchFilter,
      },
    },
  };
}

function getSecondaryStatusOptions() {
  return {
    ...assignStatusExternalSecondaryOptions,
    Application: assignStatusExternalSecondaryOptions.Application.filter((item) => item.label !== "Not submitted"),
  };
}
